(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var root = document;
    if (!document.querySelector('.hydra')) return;

    var revealEls = root.querySelectorAll('.reveal');
    var revealObs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el){ revealObs.observe(el); });

    // Safety net: force-reveal anything still hidden after 2s (guards against
    // observer/layout edge cases hiding content permanently).
    setTimeout(function(){
      revealEls.forEach(function(el){ el.classList.add('visible'); });
    }, 2000);

    var problemLines = root.querySelectorAll('.hydra-problem-line');
    var counterEl = document.getElementById('hydraProblemCounter');
    function animateCounter(){
      if (!counterEl) return;
      var target = parseInt(counterEl.dataset.target, 10) || 0;
      var start = performance.now();
      var duration = 1400;
      function step(now){
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        counterEl.textContent = Math.round(eased * target) + '%';
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var lineObs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          var lines = entry.target.closest('.hydra-problem-lines').querySelectorAll('.hydra-problem-line');
          lines.forEach(function(p, i){ setTimeout(function(){ p.classList.add('visible'); }, i * 300); });
          animateCounter();
          lineObs.unobserve(entry.target);
        }
      });
    }, { threshold: .3 });
    problemLines.forEach(function(el){ lineObs.observe(el); });

    var nav = document.getElementById('hydraNav');

    var heroGlow = root.querySelector('.hydra-hero-glow');
    var ticking = false;
    function onScrollFrame(){
      var y = window.scrollY;
      if (nav) nav.classList.toggle('scrolled', y > 60);
      if (heroGlow) {
        heroGlow.style.transform = 'translateY(' + (y * .15) + 'px) scale(' + (1 + y * .0003) + ')';
        heroGlow.style.opacity = Math.max(0, .5 - y * .001);
      }
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking) {
        requestAnimationFrame(onScrollFrame);
        ticking = true;
      }
    }, { passive: true });
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);

    var filterBar = document.getElementById('hydraFilterBar');
    if (filterBar) {
      var cards = root.querySelectorAll('.hydra-product-card');
      filterBar.addEventListener('click', function(e){
        var btn = e.target.closest('.hydra-filter-btn');
        if (!btn) return;
        filterBar.querySelectorAll('.hydra-filter-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var f = btn.dataset.filter;
        cards.forEach(function(c){
          if (f === 'all' || c.dataset.capacity === f) {
            c.style.display = '';
            c.style.opacity = '1';
            c.style.transform = '';
          } else {
            c.style.opacity = '0';
            c.style.transform = 'scale(0.95)';
            setTimeout(function(){ c.style.display = 'none'; }, 300);
          }
        });
      });
    }

    var burger = document.getElementById('hydraNavBurger');
    var drawer = document.getElementById('hydraNavDrawer');
    var backdrop = document.getElementById('hydraNavBackdrop');
    function closeDrawer(){
      if (!burger) return;
      burger.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (burger && drawer && backdrop) {
      burger.addEventListener('click', function(){
        var isOpen = drawer.classList.contains('open');
        if (isOpen) {
          closeDrawer();
        } else {
          burger.classList.add('open');
          burger.setAttribute('aria-expanded', 'true');
          drawer.classList.add('open');
          backdrop.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
      });
      backdrop.addEventListener('click', closeDrawer);
      drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeDrawer); });
    }
  });

  window.hydraToggleFaq = function(item){
    var wasOpen = item.classList.contains('open');
    var list = item.closest('.hydra-faq-list');
    list.querySelectorAll('.hydra-faq-item').forEach(function(el){ el.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  };
})();
